import React from 'react';
import ProductCard from './ProductCard';
type Product = {
  id: number;
  name: string;
  description: string;
  image: string;
  isMatching: boolean;
  intentPhrases: string[];
};
type ProductsPanelProps = {
  products: Product[];
};
const ProductsPanel: React.FC<ProductsPanelProps> = ({
  products
}) => {
  return <div className="h-full flex flex-col" data-id="element-103">
      <div className="p-4 border-b border-gray-700 flex justify-between items-center" data-id="element-104">
        <h2 className="text-xl font-semibold" data-id="element-105">Volunteer Activities</h2>
        <button className="text-xs bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded" data-id="element-106">
          Add Activity
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-3" data-id="element-107">
        {products.map(product => <ProductCard key={product.id} product={product} data-id="element-108" />)}
      </div>
    </div>;
};
export default ProductsPanel;